import { LocationIntegrationStatus } from '@constants/companies';

export const LINK_VALUE = '__link__';
export const SKIP_VALUE = '__skip__';
export const CREATE_VALUE = '__create__';

export const isLinkedToType = (location, integrationType, integrationId = null) =>
    !!location.integrations?.some(
        i =>
            i.type === integrationType &&
            i.status !== LocationIntegrationStatus.Disconnected &&
            (!integrationId || i.integrationId === integrationId),
    );
